import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { K1DashboardProvider } from "@/features/K1Dashboard/context/K1DashboardProvider";
import MastersheetView from "@/features/K1Dashboard/views/MastersheetView";

export default function K1Mastersheet() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Mastersheet");
  }, []);

  return (
    <K1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <MastersheetView />
      </main>
    </K1DashboardProvider>
  );
}
